import { api } from '@api'
import { useQuery } from '@tanstack/solid-query'
import dayjs from 'dayjs'
import { createMemo } from 'solid-js'
import { userId } from '../auth'

const getUserSubscription = async (uid: string) => {
	const { data, error } = await api()
		.from('subscription')
		.select('*')
		.eq('user_id', uid)
		.eq('is_current', true)
		.maybeSingle()

	if (error) throw new Error(error.message)
	return data
}

export function useSubscription() {
	const query = useQuery(() => ({
		queryKey: ['subscription', userId()],
		queryFn: () => getUserSubscription(userId()!),
		enabled: !!userId(),
		staleTime: Number.POSITIVE_INFINITY,
	}))

	const currentPeriodEnd = createMemo(() =>
		dayjs(query.data?.current_period_end).format('DD MMMM, YYYY'),
	)

	return {
		subscription: query,
		currentPeriodEnd,
	}
}
